// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationOutlinedSvg from "@fishx/icons-svg/es/asn/ReconciliationOutlined";
import FishxIcon from '../components/FishxIcon';

var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationOutlinedSvg
  }));
};

ReconciliationOutlined.displayName = 'ReconciliationOutlined';
export default React.forwardRef(ReconciliationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReconciliationOutlined.js
// module id = 3973
// module chunks = 0